import(/* webpackMode: "eager" */ "/vercel/path0/app/[category]/page.tsx");
